<template>
  <div v-if="visibleMessages.length > 0" class="important-messages">
    <important-message
      v-for="(message, index) in visibleMessages"
      :key="index"
      :type="message.type"
      :is-hideable="message.is_hideable === 1"
      @hide="hideMessage(message.identifier)"
    >
      <div v-html="message.message"></div>
    </important-message>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import ImportantMessage from '@/components/ImportantMessage.vue';

export default {
  name: 'ImportantMessages',
  components: {
    ImportantMessage,
  },
  data() {
    return {
      hiddenMessageIds: [],
    };
  },
  computed: {
    ...mapState({
      config: state => state.config,
      currentDevice: state => state.currentDevice,
    }),
    importantMessages() {
      return this.$store.getters.importantMessages || [];
    },
    visibleMessages() {
      // Filter out hidden messages
      return this.importantMessages.filter(message => message.is_hideable !== 1 || !this.hiddenMessageIds.includes(message.identifier));
    },
  },
  methods: {
    hideMessage(identifier) {
      // Add message id to hidden list
      if (!this.hiddenMessageIds.includes(identifier)) {
        this.hiddenMessageIds.push(identifier);
        this.saveHiddenMessages();
      }
    },
    loadHiddenMessages() {
      try {
        const savedIds = localStorage.getItem('hiddenMessageIds');
        if (savedIds) {
          this.hiddenMessageIds = JSON.parse(savedIds);
        }
      } catch (e) {
        console.error('Error loading hidden message IDs:', e);
        this.hiddenMessageIds = [];
      }
    },
    saveHiddenMessages() {
      try {
        // Clean up any IDs that are no longer in the important_messages
        this.cleanupHiddenMessages();
        localStorage.setItem('hiddenMessageIds', JSON.stringify(this.hiddenMessageIds));
      } catch (e) {
        console.error('Error saving hidden message IDs:', e);
      }
    },
    cleanupHiddenMessages() {
      // Remove IDs that no longer exist in the important_messages array
      if (this.importantMessages && this.importantMessages.length > 0) {
        const validIdentifiers = this.importantMessages
          .filter(msg => msg.is_hideable === 1)
          .map(msg => msg.identifier);

        this.hiddenMessageIds = this.hiddenMessageIds.filter(id => validIdentifiers.includes(id));
      }
    },
  },
  created() {
    this.loadHiddenMessages();
  },
  watch: {
    importantMessages: {
      handler() {
        this.cleanupHiddenMessages();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.important-messages {
  margin-bottom: 8px;
}
</style>
